export default (i) => {
  let $ = Math.PI;
  let l = Math.E;
  let x = Math.LN2;
  let q = Math.LN10;
  let _ = (Math.round((q >= x ? $ : l) * 100) / 100);
  return _;
};
